// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FileUploader_componentWrapper__968FY","button":"FileUploader_button__rmpS5","label":"FileUploader_label__2L9EU","file":"FileUploader_file__PHVO8"};